import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import TagManager from 'react-gtm-module';
import { fetchMe } from '../actions';

const cookies = new Cookies();

export default function LoggedIn(Component) {
  class AuthenticatedComponent extends React.Component {
    constructor(props) {
      super(props);
      this.state = { authed: false };
    }

    componentDidMount() {
      const { user } = this.props;
      if (user && user.me && !user.me.expires) {
        this.checkAuth();
      }
    }

    async checkAuth() {
      const path = '/' // get the current path, send it through the state
      const { dispatch, user } = this.props;
      dispatch(fetchMe(path)).then((res) => {
        if (res.type === 'FETCH_ME_SUCCESS') {
          let userId;
          let verified;
          if (res.payload && res.payload.referenceId) {
            userId = res.payload.referenceId;
          }
          if (res.payload && res.payload.flags && res.payload.flags) {
            if (res.payload.flags.verified) {
              verified = res.payload.flags.verified;
            }
          }
          const tagManagerArgs = {
            dataLayer: {
              userID: userId,
              userVerified: verified,
            },
          };
          TagManager.dataLayer(tagManagerArgs);
        }
      });
    }

    render() {
      const { user } = this.props;
      const vto = cookies.get('_vto');
      const vtoa = cookies.get('_vtoa');
      if (user && user.redirect) {
        window.location.href = user.redirect;
        // return ( <Redirect to={user.redirect} /> );
      }

      if (vto || vtoa) {
        return (<Component {...this.props}/>);
      }

      return (null);
    }
  }

  const mapStateToProps = state => ({
    token: state.user.token,
    loading: state.user.loading,
    user: state.user,
  });

  return withRouter(connect(mapStateToProps)(AuthenticatedComponent));
}
